import { getTagConfigBySliceType } from 'components/MCTextEditor/formatting/constants'
import { SliceType } from 'components/MCTextEditor/slice/types'
import { exportSmartLink } from 'components/MCTextEditor/smartLinks/adapter'
import { IVariableData } from 'components/MCTextEditor/types'
import { exportURL } from 'components/MCTextEditor/url/adapter'
import { exportVariable } from 'components/MCTextEditor/variables/adapter'
import { ISlice } from 'components/RichTextEditor/processor/constants'

export const exportSlice = (text: string, slice: ISlice): string => {
  const tagConfig = getTagConfigBySliceType(slice.type)
  if (tagConfig) {
    return tagConfig.exportSlice(text, slice)
  }

  switch (slice.type) {
    case SliceType.VARIABLE: {
      return exportVariable(slice.data as IVariableData)
    }
    case SliceType.SMART_LINK: {
      return exportSmartLink((slice.data as { buttonId: string })?.buttonId)
    }
    case SliceType.URL: {
      return exportURL(text, slice)
    }
  }

  return text
}
